import React from 'react';
import { Code2, Cpu } from 'lucide-react';

export function Technical() {
  return (
    <section id="technical" className="scroll-mt-16 bg-white rounded-xl shadow-lg p-8">
      <div className="flex items-center justify-center gap-3 mb-8">
        <Cpu className="w-8 h-8 text-indigo-600" />
        <h2 className="text-3xl font-bold text-gray-900">Technical Details</h2>
      </div>
      <div className="max-w-3xl mx-auto space-y-6">
        <div>
          <h3 className="text-xl font-semibold mb-2">AI-Powered Generation</h3>
          <p className="text-gray-600">
            Our blog title generator uses advanced natural language processing and machine learning algorithms to create compelling headlines. It analyzes successful content patterns and applies proven copywriting formulas.
          </p>
        </div>
        <div>
          <h3 className="text-xl font-semibold mb-2">SEO Optimization</h3>
          <p className="text-gray-600">
            Each generated title is optimized for search engines using data-driven keyword placement and emotional triggers that boost click-through rates.
          </p>
        </div>
        <div>
          <h3 className="text-xl font-semibold mb-2">Performance Metrics</h3>
          <p className="text-gray-600">
            Headlines are scored based on emotional impact, curiosity factor, predicted CTR, and SEO optimization to help you choose the most effective titles.
          </p>
        </div>
      </div>
    </section>
  );
}